<template>
  <v-row>
    <v-col class="mx-n2">
      <v-btn
        v-if="prev"
        color="white"
        class="c-btn mx-2"
        @click="onPrevClick"
        :disabled="prevDisabled"
        min-width="186"
      >
        Zpět
      </v-btn>
      <slot name="left-append" />
    </v-col>

    <v-col class="text-right">
      <slot name="right-prepend" />
      <v-btn
        v-if="next"
        @click="onNextClick"
        :disabled="nextDisabled"
        color="primary"
        class="c-btn mx-2"
        min-width="186"
      >
        Pokračovat
        <v-icon right>mdi-arrow-right</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ButtonBarWizard",
  props: {
    next: {
      type: [String, Boolean],
      default: null,
    },
    nextDisabled: {
      type: Boolean,
      default: false,
    },
    prev: {
      type: String,
      default: null,
    },
    prevDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onNextClick() {
      this.$emit("next")

      if (typeof this.next === "string") {
        this.$router.push(this.next)
      }
    },
    onPrevClick() {
      this.$emit("prev")

      if (typeof this.prev === "string") {
        this.$router.push(this.prev)
      }
    },
  },
}
</script>
